import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useThemeStore = create(
  persist(
    (set) => ({
      // "light" | "dark" | "system"
      theme: "system",

      setTheme: (theme) => set({ theme }),

      /** Returns the resolved theme ("light" or "dark") based on the stored
       *  preference and the OS setting when theme === "system". */
      resolvedTheme: () => {
        const stored = useThemeStore.getState().theme;
        if (stored === "system") {
          return window.matchMedia("(prefers-color-scheme: dark)").matches
            ? "dark"
            : "light";
        }
        return stored;
      },
    }),
    {
      name: "delhi-motors-theme",
    },
  ),
);
